// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"searchBox_searchBox__3Qk9u","input":"searchBox_input__374gd","icon":"searchBox_icon__1AJCJ"};